import { intersection } from "lodash";
import { fullWidthRegex } from "./regexFormat";
import { setPopUpMessageData } from "app/store/state/jobs/action";

export const isValue = (value) => value ? value : '';

export const keys = (value) => value ? Object.keys(value) : null;

export const values = (value) => value ? Object.values(value) : null;

export const valuesLength = (value) => value ? Object.values(value).length : 0;

export const entries = (value) => value ? Object.entries(value) : null;

export const length = (value) => value ? value?.length : 0;

export const isEqual = (obj1, obj2 = 0) => obj1 === obj2;

export const notEqual = (obj1, obj2 = 0) => obj1 !== obj2;

export const include = (array, option) => array ? array.includes(option) : false

export const isTypeNumber = (value) => value || value >= 0 ? isEqual(typeof value, "number") : false;

export const type = (value) => typeof value;

export const replaceAll = (value, character, replace) => value ? value.replaceAll(character, replace) : value;

export const replace = (value, character, replace) => value ? value.replace(character, replace) : value;

export const join = (value, joinString) => value ? value?.join(joinString) : value;

export const lesserEqual = (obj1, obj2 = 0) => obj1 <= obj2;

export const toLower = (value) => value ? value?.toLowerCase() : '';

export const toUpper = (value) => value ? value?.toUpperCase() : '';

export const isArray = (value) => value ? Array.isArray(value) : false;

export const trim = (value) => value ? value.trim() : value;

export const trimLeft = (value) => value ? value.trimLeft() : value;

export const removeDuplicate = (arrayList) => intersection(...arrayList)

export const splitStr = (value, obj) => value ? value?.split(obj) : null;

export const ternary = (value, truthy, falsy) => (value ? truthy : falsy)

export const convertToHalf = (value, isNumber) => {
    const isFullWidth = fullWidthRegex.test(value);
    let tempValue = value
    if (isFullWidth && isNumber) {
        tempValue = value?.toString()?.replace(fullWidthRegex, '');
        window.redux(setPopUpMessageData({ modal: true, message: ["msgFullWidthText"], }))
    }
    return tempValue
}

export const apiParams = ({ params, pageNo }) => {
    let tempParams = ''
    if (pageNo) {
        tempParams += `${pageNo}`
    }
    entries(params)?.forEach(([key, value], i) => {
        tempParams += `${ternary(isEqual(i, 0), '?', '&')}${key}=${value}`
    })
    return tempParams
}
